import type { Baseline } from '@shared/models/project.model';
import type { ProposalId } from '@shared/models/proposals.model';
import type { ProjectChange } from '../update-engine.models';
import { buildProposalAppendActionPatch } from '../../actions/apply-changes-to-proposal.helpers';

/**
 * Append a new {@link Action} on a {@link Baseline} and link it on a
 * {@link IProposal}.
 *
 * Wraps {@link buildProposalAppendActionPatch} (which condenses the inner changes,
 * subtracts overlapping prior actions, drops baseline no-ops and creates the action) into
 * a structural mutator that returns the full updated version.
 *
 * Returns the same {@link version} reference when nothing meaningful is appended.
 */
export const appendProposalAction = (
  version: Baseline,
  proposalId: ProposalId,
  changes: ProjectChange[],
): Baseline => {
  const patch = buildProposalAppendActionPatch(version, proposalId, changes);
  if (!patch) return version;
  return { ...version, ...patch };
};
